// extracted by mini-css-extract-plugin
module.exports = {"arrowForward":"location-delivery-display_arrowForward__3Kqa4","searchSection":"location-delivery-display_searchSection__1QoQt"};